<script>
export default {
  props: {
    users: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      searchText: '',
      searchInput: null,
      searchedColumn: '',
      columns: [
        {
          title: 'Email',
          dataIndex: 'email',
          key: 'email',
          scopedSlots: {
            customRender: 'customRender',
          },
          defaultSortOrder: 'ascend',
          sorter: (a, b) => a.email.localeCompare(b.email),
        },
        {
          title: 'Name',
          dataIndex: 'name',
          key: 'name',
          scopedSlots: {
            customRender: 'customRender',
          },
          defaultSortOrder: 'ascend',
          sorter: (a, b) => a.name.localeCompare(b.name),
        },
        {
          title: 'Organization',
          dataIndex: 'organization',
          key: 'organization',
          scopedSlots: {
            customRender: 'customRender',
          },
          defaultSortOrder: 'ascend',
          sorter: (a, b) => a.organization.localeCompare(b.organization),
        },
        {
          title: 'Role',
          dataIndex: 'role',
          key: 'role',
          scopedSlots: {
            customRender: 'customRender',
          },
          defaultSortOrder: 'ascend',
          sorter: (a, b) => a.role.localeCompare(b.role),
        },
        {
          title: 'Actions',
          key: 'actions',
          scopedSlots: {
            customRender: 'customRender',
          },
        },
      ],
    }
  },
  methods: {
    selectRow(record) {
      const userId = record.pk.replace('USER#', '')
      this.$router.push({
        name: 'user-profile',
        params: { userId },
      })
    },
    onDelete(record) {
      this.$emit('deleteUser', record)
    },
  },
}
</script>

<template>
  <a-table :data-source="users" :columns="columns">
    <template slot="customRender" slot-scope="text, record, index, column">
      <template>
        <div v-if="column.key === 'email'" style="text-transform: none">
          <a @click="() => selectRow(record, column)">{{ text }}</a>
        </div>
        <div v-else-if="column.key === 'role'">
          <a-tag v-if="text === 'super'" :color="'pink'">
            {{ text.toUpperCase() }}
          </a-tag>
          <a-tag v-else :color="text === 'admin' ? 'purple' : 'blue'">
            {{ text.toUpperCase() }}
          </a-tag>
        </div>
        <div v-else-if="column.key === 'actions'">
          <ul class="actions">
            <li>
              <a
                href="javascript:;"
                title="Edit User"
                @click="() => selectRow(record, column)"
                ><a-button type="primary" icon="edit" size="small"></a-button
              ></a>
            </li>
            <li>
              <a-popconfirm
                title="Sure to delete?"
                @confirm="() => onDelete(record)"
              >
                <a href="javascript:;" title="Delete User"
                  ><a-button type="danger" icon="delete" size="small"></a-button
                ></a>
              </a-popconfirm>
            </li>
          </ul>
        </div>
        <div v-else>{{ text }}</div>
      </template>
    </template>
  </a-table>
</template>

<style scoped>
.highlight {
  padding: 0;
  background-color: rgb(255, 192, 105);
}
</style>
